import { useEffect } from "react";
import { MapContainer, TileLayer, CircleMarker, Tooltip, useMap } from "react-leaflet";
import { BASEMAPS } from "@/components/dispatchmap/mapShared";

const FitAll = ({ pts }) => {
  const map = useMap();
  useEffect(() => {
    if (!pts.length) return;
    if (pts.length === 1) map.setView([pts[0].lat, pts[0].lng], 15);
    else map.fitBounds(pts.map((p) => [p.lat, p.lng]), { padding: [18, 18], maxZoom: 15 });
  }, [pts.map((p) => `${p.lat},${p.lng}`).join("|")]); // eslint-disable-line
  return null;
};

// Mini map of candidate landmark pins (numbered) so dispatch can eyeball which one the caller means.
export const HintMiniMap = ({ candidates = [], selected, onPick, near }) => {
  const pts = candidates.filter((c) => Number.isFinite(c.lat) && Number.isFinite(c.lng));
  if (!pts.length) return null;
  const center = near ? [near.lat, near.lng] : [pts[0].lat, pts[0].lng];
  return (
    <div data-testid="hint-mini-map" className="h-44 w-full border border-[#2C2D35] rounded-sm overflow-hidden relative">
      <MapContainer center={center} zoom={13} style={{ height: "100%", width: "100%" }} zoomControl={false} attributionControl={false} scrollWheelZoom={false}>
        <TileLayer url={BASEMAPS.streets.url} attribution={BASEMAPS.streets.attr} />
        <FitAll pts={near ? [...pts, near] : pts} />
        {near && <CircleMarker center={[near.lat, near.lng]} radius={6} pathOptions={{ color: "#3B82F6", fillColor: "#1D4ED8", fillOpacity: 0.9 }}><Tooltip direction="top"><span className="font-mono text-[10px]">Call / caller GPS</span></Tooltip></CircleMarker>}
        {pts.map((c, i) => (
          <CircleMarker key={i} center={[c.lat, c.lng]} radius={selected === i ? 11 : 9} eventHandlers={{ click: () => onPick?.(c, i) }}
            pathOptions={{ color: selected === i ? "#FFFFFF" : "#F59E0B", fillColor: selected === i ? "#F59E0B" : "#78350F", fillOpacity: 0.95, weight: 2 }}>
            <Tooltip permanent direction="center" className="hint-num-tip"><span className="font-mono font-bold text-[10px]">{i + 1}</span></Tooltip>
            <Tooltip direction="top" offset={[0, -10]}><span className="font-mono text-[10px]">{c.name || c.address}</span></Tooltip>
          </CircleMarker>
        ))}
      </MapContainer>
      <div className="absolute bottom-1 left-1 bg-black/70 px-1.5 py-0.5 font-mono text-[8px] text-[#FCD34D] z-[400]">Click a numbered pin to choose it · hover for name</div>
    </div>
  );
};
